
import React from 'react';
import { Button } from '@/components/ui/button';
import { Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-itmgmt-dark-blue text-white py-16 md:py-24">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="heading-xl mb-6">
              Project Consulting
            </h1>
            <p className="text-xl mb-8 text-gray-300">
              Strategic guidance to align technology with your business objectives and drive growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild className="button-primary">
                <Link to="/book?service=consulting">Book a Consultation</Link>
              </Button>
            </div>
          </div>
          <div className="hidden lg:flex justify-center">
            <div className="bg-itmgmt-medium-blue bg-opacity-20 p-8 rounded-full">
              <Briefcase size={120} className="text-itmgmt-bright-blue" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
